import LockupAttributes from './lockupAttributes'

export default LockupAttributes
